import { defineComponent as _defineComponent } from 'vue'
import { useDeleteReviewRequestMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteReview',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  reviewId: {
    type: String,
    default: null,
  },
},
  emits: ["input", "deleted"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'deleted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { mutate: deleteReviewRequest, loading } = useDeleteReviewRequestMutation()

const close = () => {
  emit('input', false)
}

const confirmDelete = async () => {
  if (!props.reviewId) {
    return
  }
  await deleteReviewRequest({ id: props.reviewId })
  emit('deleted')
  close()
}

return { __sfc: true,props, emit, deleteReviewRequest, loading, close, confirmDelete }
}

})